import Cookies from 'js-cookie';

import {
  LOGIN_WITH_OAUTH_FAIL,
  LOGIN_WITH_OAUTH_LOADING,
  LOGIN_WITH_OAUTH_SUCCESS,
  LOGIN_WITH_TOKEN_FAIL,
  LOGIN_WITH_TOKEN_LOADING,
  LOGIN_WITH_TOKEN_SUCCESS,
  LOGIN_WITH_WHATSAPP_FAIL,
  LOGIN_WITH_WHATSAPP_LOADING,
  LOGIN_WITH_WHATSAPP_SUCCESS,
  LOGOUT_SUCCESS,
  ME_FAIL,
  ME_LOADING,
  ME_SUCCESS,
  SEND_WHATSAPP_TOKEN_FAIL,
  SEND_WHATSAPP_TOKEN_LOADING,
  SEND_WHATSAPP_TOKEN_SUCCESS,
} from '../types';

const initialState = {
  token: Cookies.get('wf-token'),
  isAuthenticated: false,
  isLoading: false,
  me: null,
  error: null,
  appLoaded: false,
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    // ME actions
    case ME_LOADING:
      return {
        ...state,
        isLoading: true,
        appLoaded: false,
        error: null,
      };
    case ME_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        me: payload.me,
        error: null,
        appLoaded: true,
      };

    case ME_FAIL:
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
        me: null,
        error: payload.error,
        appLoaded: true,
      };

    // LOGIN loading states
    case LOGIN_WITH_OAUTH_LOADING:
    case LOGIN_WITH_TOKEN_LOADING:
    case LOGIN_WITH_WHATSAPP_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    // LOGIN success states
    case LOGIN_WITH_OAUTH_SUCCESS:
    case LOGIN_WITH_WHATSAPP_SUCCESS:
    case LOGIN_WITH_TOKEN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        token: payload.token,
        me: payload.me,
        error: null,
        appLoaded: true,
      };

    // LOGIN fail states
    case LOGIN_WITH_OAUTH_FAIL:
    case LOGIN_WITH_WHATSAPP_FAIL:
    case LOGIN_WITH_TOKEN_FAIL:
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
        token: null,
        me: null,
        error: payload.error,
        appLoaded: payload.isNetworkAvailable ?? true,
      };

    // WHATSAPP token states
    case SEND_WHATSAPP_TOKEN_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case SEND_WHATSAPP_TOKEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case SEND_WHATSAPP_TOKEN_FAIL:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };

    case LOGOUT_SUCCESS:
      return {
        ...state,
        token: null,
        me: null,
        isAuthenticated: false,
        isLoading: false,
        error: null,
      };
    default:
      return state;
  }
}
